// DonutFileStatusChart.jsx
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

// Center text plugin
const centerTextPlugin = {
  id: "centerText",
  beforeDraw: (chart) => {
    const { width, height } = chart;
    const ctx = chart.ctx;
    ctx.restore();

    const text1 = "Task Status";
    const total = chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
    const text2 = `Tasks: ${total}`;

    ctx.font = "bold 14px sans-serif";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillStyle = "#444";

    ctx.fillText(text1, width / 2, height / 2 - 10);
    ctx.fillText(text2, width / 2, height / 2 + 10);
    ctx.save();
  },
};

const DonutFileStatusChart = ({ completed, review, notStarted }) => {
  const data = {
    labels: ["Completed", "Ready for Review", "Not Started"],
    datasets: [
      {
        data: [completed, review, notStarted],
        backgroundColor: ["#28a745", "#ffc107", "#dc3545"], // green, yellow, red
        borderWidth: 2,
      },
    ],
  };

  const options = {
    cutout: "70%",
    plugins: {
      legend: { display: false },
    },
  };

  return (
    <Doughnut data={data} options={options} plugins={[centerTextPlugin]} />
  );
};

export default DonutFileStatusChart;
